import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const SidebarActions = ({ onEdit }) => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const handlePreviewCourse = () => {
    navigate(`/preview/${courseId}`);
  };

  const handleShareCourse = () => {
    const courseUrl = `${window.location.origin}/course/${courseId}`;
    navigator.clipboard.writeText(courseUrl)
      .then(() => {
        alert('Course link copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        alert('Failed to copy link. Please try again.');
      });
  };

  const handleViewAnalytics = () => {
    navigate(`/courses/${courseId}/analytics`);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="space-y-3">
        <button
          onClick={onEdit}
          className="w-full px-4 py-3 bg-green-500 text-white rounded-lg font-semibold transition-all duration-300 hover:bg-green-600 hover:scale-105 flex items-center justify-center space-x-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          <span>Edit Course</span>
        </button>
        
        {/* <button
          onClick={handlePreviewCourse}
          className="w-full px-4 py-3 bg-blue-500 text-white rounded-lg font-semibold transition-all duration-300 hover:bg-blue-600 hover:scale-105 flex items-center justify-center space-x-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span>Preview Course</span>
        </button> */}
        
        {/* <button
          onClick={handleShareCourse}
          className="w-full px-4 py-3 bg-purple-500 text-white rounded-lg font-semibold transition-all duration-300 hover:bg-purple-600 hover:scale-105 flex items-center justify-center space-x-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
          <span>Share Course</span>
        </button> */}
        
        {/* <button
          onClick={handleViewAnalytics}
          className="w-full px-4 py-3 bg-yellow-500 text-white rounded-lg font-semibold transition-all duration-300 hover:bg-yellow-600 hover:scale-105 flex items-center justify-center space-x-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span>View Analytics</span>
        </button> */}
      </div>
    </div>
  );
};

export default SidebarActions;